import controller from './family-plan-member-start-listen-dialog.controller';

export default {
  controller,
  template: require('./family-plan-member-start-listen-dialog.html')
};



// WEBPACK FOOTER //
// src/app/family-plan/family-plan-member-start-listen-dialog/family-plan-member-start-listen-dialog.component.ts